
    import CadastroInline from '@/components/aplicacao/CadastroInline.vue'; 
    import BotaoSalvar from '@/components/aplicacao/BotaoSalvar.vue';
    import ListaCampoForm from '@/components/aplicacao/ListaCampoForm.vue';  
    import {  Profile } from "./Profile"; 
    import   SiteUtils   from '@/assets/ts/aplicacao/site'; 
    import { Options, Vue  } from "vue-class-component";  
    import UsuarioService from   "@/service/v10/seguranca/UsuarioService"

    @Options({
        name: "ProfileIndex",
        components: { CadastroInline, BotaoSalvar, ListaCampoForm },   
    }) 
    export default class ProfileIndex extends Vue {
        
        public service:any = null ; 
        public campos: Array<any> = [ ]; 
        public index = 1 ;  
        public editando = false;
        public processando = false;
        public isModelBuscado  = false ;  
        public isModelCriado  = true ; 
        public formulario: any  = {} ;
        public modelo: any  = {} ;
    
        created() {  
            this.service = new UsuarioService();  
            this.campos =  Profile.campos();  
            this.buscarDados( );
        }
    
        public buscarDados(){   
            this.editando = false ;  
            this.isModelCriado = false;
            this.isModelBuscado = false; 
            this.service.getMeusDados( ) 
            .then(response => {  
                this.modelo =  JSON.parse(JSON.stringify( response ));   
                this.preparardados( ) ;  
            })
            .catch(error => {
                this.formulario = { }; 
                this.isModelCriado = false;
                this.isModelBuscado = true;
            });  
		}
 
        public cancelar(){  
            this.preparardados() ;  
            this.editando = false ; 
            this.index++;
        }
 
        public preparardados(   ){   
            this.editando = false ;  
            this.formulario = JSON.parse(JSON.stringify( this.modelo ));   
            this.index++;
            this.isModelCriado = true;
            this.isModelBuscado = true; 
		}
 
        get hasPermissao(   ): boolean { 
            return true; 
        }

        public atualizar(){ 
            let dados = this.getdadosatualizar() ;   
            this.service.updateMeusDados(   dados )
            .then(response => { 
                SiteUtils.toastSucesso('Atualizado com sucesso! ' ,  response.message  );
                this.buscarDados();
                this.sucesso();  
                this.processando = false ; 
                this.editando = false ;
            }) 
            .catch(error => {
                this.processando = false ;
                SiteUtils.toastErro('Error! ' ,  error.data.message  );
            });   
        } 
          
        public editar(){ 
            if( this.hasPermissao ){
                this.editando = true ;  
            }
            else {
                 this.editando = false ;
            } 
        }
 
        public sucesso(){  
            console.log('sucesso');
        }
 
        public getdadosatualizar(){  
            let dados = JSON.parse(JSON.stringify(this.formulario)); 
            return dados;
        }
 
        public salvar(){ 
            if( this.processando  ||  !this.hasPermissao ){
                return;
            }
            this.processando = true ;  
            setTimeout(() => {
                if( this.formulario.id ){
                    this.atualizar();  
                } 
            }, 20);  
        } 
 
    } 
